import BlankLayout from '@/views/personalNew/layout/blankLayout.vue'
import CommonLayout from '@/views/personalNew/layout/commonLayout.vue'
import pcInterview from './pc/index.vue'
import mobileInterview from './mobile/index.vue'
import { deviceType } from '@/utils/common'

const basePath = '/recruiting/personal/interview'

export default {
  path: `${basePath}`,
  component: deviceType.isPc ? CommonLayout : BlankLayout,
  meta: {
  },
  children: [
    {
      path: `${basePath}/confirm-time`,
      component: deviceType.isPc ? pcInterview : mobileInterview,
      meta: {
        titleI18nKey: 'personal.interview.title.interview'
      }
    }
  ]
}
